import { Component } from '../core/smpl-components'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin.js'

gsap.registerPlugin(MorphSVGPlugin)

// -------------------------------------------------------------------------- //
// Morphs the card's arrow icon into its (invisible) `#morph-target` shape on
// hover. Ids are duplicated across cards on the page, so everything is scoped
// to `this.element` and morphSVG is handed element references — never `#id`
// selector strings — so a card can only ever morph its own path.
// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		this.elArrow = this.element.querySelector('#arrow')
		this.elTarget = this.element.querySelector('#morph-target')

		if (!this.elArrow || !this.elTarget) return

		// Reversible morph, parked at the start. Hover plays it, leave reverses.
		this.tween = gsap.to(this.elArrow, {
			morphSVG: this.elTarget,
			duration: 0.2,
			ease: 'power2.inOut',
			paused: true,
		})

		this.bndEnter = () => this.tween.play()
		this.bndLeave = () => this.tween.reverse()
	}

	mount() {
		if (!this.tween) return
		this.element.addEventListener('pointerenter', this.bndEnter)
		this.element.addEventListener('pointerleave', this.bndLeave)
	}

	unmount() {
		if (!this.tween) return
		this.element.removeEventListener('pointerenter', this.bndEnter)
		this.element.removeEventListener('pointerleave', this.bndLeave)
		this.tween.kill()
	}
}
